import { render, staticRenderFns } from "./ThreePLOrderStatusForm.vue?vue&type=template&id=320d809c"
import script from "./ThreePLOrderStatusForm.vue?vue&type=script&lang=js"
export * from "./ThreePLOrderStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports